import { LineItem } from '@pperform/pp-data-mappers';

export const getStateKey = (forwardLineItem: LineItem) => forwardLineItem.guid;
